<div class="backBackground">
  <div class="transitionEffectAll600 roundedCorner" [ngClass]="{
    mainZero:  auth.currentUserIDSig()?.uid == null,
    mainMax:
      sb.currentSidebarSize() === 'max' &&
       auth.currentUserIDSig()?.uid != null,
    mainMin:
      sb.currentSidebarSize() === 'min' &&
       auth.currentUserIDSig()?.uid != null
  }" *transloco="let t">
    <div class="page-content container-fluid base-font-color">
      <div class="row">
        <div class="col p-0 p-md-1">
          @if ( auth.currentUserIDSig()?.uid != null) { @if(showSpinner ||
          !this.auth.currentLangSig()?.lang) {
          <div class="row">
            <div class="col">
              <span class="placeholder-glow">
                <span class="placeholder placeholder-lg col-4"></span>
              </span>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col text-center">
              <div class="svl-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          } @if (!showSpinner && this.auth.currentLangSig()?.lang) {
          <div class="d-flex justify-content-between my-3">
            <div class="page-header base-font-color flex-grow-1">
              <h2 title="{{t('transactions.header-title')}}">{{ t('transactions.header-title') }}</h2>
            </div>
            <div class="w-50 d-none d-lg-block">
              <form #SearchPhraseForm="ngForm" autocomplete="off" class="super-font">
                <datalist id="availableCategories">
                  <option class="dropdown-item" *ngFor="let category of catsArray" value="{{category.content['name']}}">
                </datalist>

                <div class="input-group">
                  @if(searchColumn == 'category') {
                  <input type="text" class="form-control form-font my-0" list="availableCategories" #phrase="ngModel"
                    [(ngModel)]="searchPhraseModel.phrase" name="phrase" type="text" id="searchPhrase"
                    placeholder="{{ t('transactions.click-select') }}">
                  } @else {
                  <input type="text" class="form-control" placeholder="{{ t('transactions.search') }}" #phrase="ngModel"
                    [(ngModel)]="searchPhraseModel.phrase" name="phrase" type="number" id="searchPhrase">
                  }
                  <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">{{ t("transactions.list-col-" + searchColumn) }}</button>


                  <ul class="dropdown-menu dropdown-menu-end">
                    <li class="dropdown-item" *ngFor="let option of availableSearchColumns"
                      (click)="selectSearchField(option)">
                      {{ t("transactions.list-col-" + option) }}
                    </li>
                  </ul>


                  <button class="btn btn-outline-secondary" type="button"
                    [ngClass]="{'disabled': searchPhraseModel.phrase == ''}"
                    (click)="searchTransactions(searchColumn, searchPhraseModel.phrase)">
                    <span class="material-symbols-outlined m-1 cursor-pointer category-toggle-icon mt-1">search</span>
                  </button>
                </div>
              </form>
            </div>

            <div class="d-flex d-block d-lg-none">
              <span class="material-symbols-outlined m-1 cursor-pointer category-toggle-icon my-auto"
                (click)="toggleSearch()">
                search
              </span>
            </div>
            <div class="d-flex">
              <span class="material-symbols-outlined m-1 cursor-pointer category-toggle-icon my-auto"
                (click)="toggleTransactionsView(this.transactionsView)"
                title="{{ t('transactions.grid-table-title') }}">
                @if (transactionsView ==='grid') { table } @else { grid_view }
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-6">
              <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"
                [ngClass]="{'d-none': this.searchFlag == true || this.searchPanel == true}">
                <div class="btn-group btn-group-sm w-100" role="group" aria-label="Second group">
                  <button type="button" class="btn btn-outline-secondary px-1"
                    [ngClass]="{'disabled': this.periodDisplay == 'start'}"
                    (click)="updatePeriodsToDisplay('prev')"><span
                      class="material-symbols-outlined mt-1">chevron_left</span></button>
                  <button type="button" class="btn btn-outline-secondary px-1 flex-fill"
                    [ngClass]="{'active': period == selectedPeriod}"
                    *ngFor="let period of periodsToDisplay; let i = index" (click)="selectPeriod(period)">{{
                    t('calendar.'+ period)}}</button>
                  <button type="button" class="btn btn-outline-secondary px-1"
                    [ngClass]="{'disabled': this.periodDisplay == 'end'}" (click)="updatePeriodsToDisplay('next')"><span
                      class="material-symbols-outlined mt-1">chevron_right</span></button>
                  <button type="button" class="btn btn-outline-secondary px-1"
                    [ngClass]="{'disabled': this.periodDisplay == 'start'}"
                    (click)="updatePeriodsToDisplay('reset')"><span
                      class="material-symbols-outlined mt-1">refresh</span></button>
                </div>
              </div>
            </div>


            <!-- <div class="btn-group btn-group-sm ms-2 d-none d-md-block" role="group" aria-label="Third group">
            <button type="button" class="btn btn-outline-secondary px-1"
              [ngClass]="{'disabled': this.periodDisplay == 'start'}" (click)="updatePeriodsToDisplay('reset')"><span
                class="material-symbols-outlined mt-1">refresh</span></button>
          </div> -->
          </div>

          <div class="row d-lg-none" [ngClass]="{'d-none': this.searchPanel == false}">
            <div class="col mx-auto">
              <form #SearchPhraseForm="ngForm" autocomplete="off" class="super-font">
                <datalist id="availableCategories">
                  <option class="dropdown-item" *ngFor="let category of catsArray" value="{{category.content['name']}}">
                </datalist>

                <div class="input-group input-group-sm">
                  @if(searchColumn == 'category') {
                  <input type="text" class="form-control form-font my-0" list="availableCategories" #phrase="ngModel"
                    [(ngModel)]="searchPhraseModel.phrase" name="phrase" type="text" id="searchPhrase"
                    placeholder="{{ t('transactions.click-select') }}">
                  } @else {
                  <input type="text" class="form-control" placeholder="{{ t('transactions.search') }}" #phrase="ngModel"
                    [(ngModel)]="searchPhraseModel.phrase" name="phrase" type="number" id="searchPhrase">
                  }
                  <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">{{ t("transactions.list-col-" + searchColumn) }}</button>


                  <ul class="dropdown-menu dropdown-menu-end">
                    <li class="dropdown-item" *ngFor="let option of availableSearchColumns"
                      (click)="selectSearchField(option)">
                      {{ t("transactions.list-col-" + option) }}
                    </li>
                  </ul>


                  <button class="btn btn-outline-secondary" type="button"
                    (click)="searchTransactions(searchColumn, searchPhraseModel.phrase)">
                    <span class="material-symbols-outlined m-1 cursor-pointer category-toggle-icon mt-1">search</span>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="row mt-2" [ngClass]="{'d-none': this.searchFlag == false} ">
            <div class="col">
              <div class="btn btn-outline-danger" (click)="clearSearch()">{{ t("transactions.button-clear-search") }}
              </div>
            </div>
          </div>

          @if (transactionsView ==='grid') {
          <div class="row mt-3">
            <div class="col">

              <div class="list-group shadow-sm mb-2" *ngFor="let trans of transactions; index as i">
                <div class="list-group-item" title="{{ t('transactions.grid-card-id-title', {id: trans.ID}) }}">
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <div class="d-flex align-items-center">
                          <div class="cardHeight">
                            <span class="badge bg-text-blue mt-0">#{{
                              trans.ID }}
                            </span>
                          </div>
                          <div class="cardHeight mt-1 ms-1">{{ trans.Date }}</div>
                          @if(this.isDuplicate(trans.ID)) {
                          <div class="cardHeight mt-1 ms-2" title="{{ t('transactions.duplicate-mark') }}">
                            <span class="material-symbols-outlined align-items-center"
                              style="color: rgb(201, 59, 59);">brightness_alert</span>
                          </div>
                          }

                          <div class="cardHeight ms-auto">
                            <h1 class="lead">
                              <b>{{
                                (trans.Amount ?? 0)
                                | currency
                                : this.db.currentUserDataSig()?.currency ?? 'PLN'
                                : 'symbol-narrow'
                                }}</b>
                            </h1>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="material-symbols-outlined align-items-center method-button">location_on</span>
                          <div class="ms-3 align-items-center">
                            <span class="lead text-start">{{ trans.Where }}</span>
                          </div>
                        </div>
                      </div>
                      <hr />

                      @if (trans.Description) {
                      <div class="d-flex align-items-center m-0 ps-0">
                        <span class="material-symbols-outlined align-items-center method-button">format_quote</span>
                        <div class="ms-3 align-items-center">
                          <small>{{ trans.Description }}</small>
                        </div>
                      </div>
                      <hr />
                      }
                      <div class="row">
                        <div class="col">
                          <div class="row">
                            <div class="d-flex flex-row">
                              <div class="flex-grow-1">
                                <div class="d-flex align-items-center">
                                  <span
                                    class="material-symbols-outlined align-items-center method-button">view_column</span>
                                  <div class="ms-3 align-items-center">
                                    <small>{{ trans.Category }} -
                                      {{ trans.SubCategory }}</small>
                                  </div>
                                </div>
                                <div class="d-flex align-items-center">
                                  <span class="material-symbols-outlined align-items-center method-button">wallet</span>
                                  <div class="ms-3 align-items-center">
                                    <small>{{ trans.Method }} -
                                      {{ trans.Account }}</small>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <div>
                                  <span class="material-symbols-outlined method-button method-blue"
                                    data-bs-toggle="modal" data-bs-target="#transactionDetailsModal" (click)="
                                    this.selectedTrans = trans;
                                    this.selectedTransIndex = i
                                  " title="{{ t('transactions.more-details') }}">apps</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row d-none">
                        <div class="col">
                          <div class="row shadow-sm py-2" *ngIf="1">
                            <div class="d-flex flex-row">
                              <i class="material-icons-round me-1 align-self-center icon-blue">format_quote</i>
                              <div class="text-center text-nowrap greyed-out font-italic ms-auto">
                                trans.Description
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @else {

          <div class="card ps-1 pt-1 pe-1 pb-0 mt-3 mx-0">
            <div class="d-block d-sm-none">
              <!-- TABELA XS NAJMNIEJSZA -->
              <table class="table mb-0 border-bottom-white">
                <thead>
                  <tr>
                    <div class="row border-bottom p-1 m-0">
                      <div class="col mx-0">
                        <div class="row">
                          <div class="col d-flex align-items-center transactions-table-data-xs">
                            <span class="me-auto fw-bold">
                              {{ t('transactions.list-col-date') }}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col d-flex align-items-center transactions-table-data-xs">
                            <span class="fw-bold">
                              {{ t('transactions.list-col-where') }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col d-flex align-items-top mx-0 p-0">
                        <span class="ms-auto fw-bold transactions-table-data-xs">{{ t('transactions.list-col-amount')
                          }}</span>
                      </div>
                      <div class="col-2 d-flex align-items-top mx-0 p-0">
                        <span class="ms-auto fw-bold transactions-table-data-xs">

                        </span>
                      </div>
                    </div>


                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let trans of transactions; index as i">
                    <div class="row border-bottom p-1 m-0">
                      <div class="col-10 mx-0">
                        <div class="row">
                          <div class="col d-flex align-items-center transactions-table-data-xs">
                            <span class="me-auto fw-light">
                              <span>{{ trans.Date }}</span>
                            </span>
                          </div>
                          <div class="col d-flex align-items-center transactions-table-data-xs">
                            <span class="ms-auto fw-bold">
                              {{
                              trans.Amount
                              | currency
                              : this.db.currentUserDataSig()?.currency
                              : 'symbol-narrow'
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col d-flex align-items-center transactions-table-data-xs">
                            <span
                              class="material-symbols-outlined align-items-center transactions-table-data-xs-icon">location_on</span>
                            <div class="ms-2 align-items-center">
                              <span class="fst-italic">
                                @if (trans.Where.length > 30) {
                                {{ trans.Where | slice: 0:30 }}... } @else {
                                {{ trans.Where }}
                                }

                              </span>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="col-2 d-flex align-items-center px-0">
                        <span class="material-symbols-outlined method-button method-blue mx-auto" data-bs-toggle="modal"
                          data-bs-target="#transactionDetailsModal" (click)="
                            this.selectedTrans = trans;
                            this.selectedTransIndex = i
                          " title="{{ t('transactions.more-details') }}">apps</span>
                        @if(this.isDuplicate(trans.ID)) {
                        <div class="mx-auto mt-2" title="{{ t('transactions.duplicate-mark') }}">
                          <span class="material-symbols-outlined align-items-center"
                            style="color: rgb(201, 59, 59);">brightness_alert</span>
                        </div>
                        }
                        @if(!this.isDuplicate(trans.ID)) {
                        <span class="material-symbols-outlined align-items-center mx-auto mt-2"
                          style="visibility: hidden;">brightness_alert</span>
                        }
                      </div>
                    </div>


                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-none d-sm-block">
              <!-- TABELA DUŻA NORMALNA -->
              <table class="table mb-0 border-bottom-white">
                <thead>
                  <tr>
                    <th class="text-start">
                      <span class="transactions-table-header">{{ t('transactions.list-col-date') }}</span>
                    </th>
                    <th class="text-end">
                      <span class="transactions-table-header">{{ t('transactions.list-col-amount') }}</span>
                    </th>
                    <th class="text-center">
                      <span class="transactions-table-header">{{ t('transactions.list-col-category') }}</span>
                    </th>
                    <th class="text-center">
                      <span class="transactions-table-header">{{ t('transactions.list-col-where') }}</span>
                    </th>
                    <th class="text-center">
                      <span class="transactions-table-header">{{ t('transactions.list-col-actions') }}</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let trans of transactions; index as i">
                    <td class="transactions-table-box text-start">
                      <div class="mt-1 text-nowrap transactions-table-data">{{ trans.Date }}</div>
                    </td>
                    <td class="transactions-table-box text-end">
                      <div class="mt-1 text-nowrap transactions-table-data">
                        {{trans.Amount | currency: this.db.currentUserDataSig()?.currency: 'symbol-narrow'}}
                      </div>
                    </td>
                    <td class="transactions-table-box text-center">
                      <div class="mt-1 text-nowrap transactions-table-data">
                        {{ trans.Category }}
                      </div>
                    </td>
                    <td class="transactions-table-box text-center">
                      <div class="mt-1 text-wrap transactions-table-data fst-italic">
                        @if (trans.Where.length > 30) {
                        {{ trans.Where | slice: 0:30 }}... } @else {
                        {{ trans.Where }}
                        }
                      </div>
                    </td>
                    <td class="transactions-table-box text-center">
                      <div class="d-flex justify-content-end">
                        <div class="material-symbols-outlined method-button method-blue" data-bs-toggle="modal"
                          data-bs-target="#transactionDetailsModal" (click)="
                        this.selectedTrans = trans; this.selectedTransIndex = i
                      " title="{{ t('transactions.more-details') }}">apps</div>
                        @if(this.isDuplicate(trans.ID)) {
                        <div class="" title="{{ t('transactions.duplicate-mark') }}">
                          <span class="material-symbols-outlined align-items-center"
                            style="color: rgb(201, 59, 59);">brightness_alert</span>
                        </div>
                        }
                        @if(!this.isDuplicate(trans.ID)) {
                        <span class="material-symbols-outlined align-items-center"
                          style="visibility: hidden;">brightness_alert</span>
                        }
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          }

          <div class="container text-center">
            @if (this.transactions.length == 0) {
            <div class="alert">
              <p><em>{{ t('transactions.no-transactions') }}</em></p>
            </div>
            }
            @if (this.lastPage==false && this.searchFlag == false && transactions.length > 0) {
            <button class="btn btn-sm rounded-pill" type="button" (click)="this.getNextTransactions()">
              <span class="material-symbols-outlined align-items-center method-button mt-1"
                title="{{ t('transactions.more-transactions') }}">expand_circle_down</span>
            </button>
            }
          </div>

          } } @if ( auth.currentUserIDSig()?.uid == null) {
          <div class="row">
            <div class="col">
              <span class="placeholder-glow">
                <span class="placeholder placeholder-lg col-4"></span>
              </span>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col text-center">
              <div class="svl-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>
<!-- MODALS -->
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="deleteTransactionModal" tabindex="-1"
  aria-labelledby="deleteTransactionModalLabel" aria-hidden="true" *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-red align-content-center">
              delete
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            @if (this.selectedTrans) {
            <h4>
              {{ t('transactions.remove-transaction') }} #{{
              this.selectedTrans?.['ID']
              }}
            </h4>
            <i>{{ t('transactions.irreversible') }}</i>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="container-fluid">
          @if (!this.auth.currentLangSig()?.lang) {
          <p class="card-text placeholder-glow">
            <span class="placeholder bg-white col-8"></span>
            <span class="placeholder col-4"></span>
          </p>
          } @if (this.auth.currentLangSig()?.lang) {
          <div class="row">
            <div class="col">
              <button class="btn btn-outline-secondary rounded-pill w-100" data-bs-dismiss="modal" type="button"
                title="{{t('general.button-cancel')}}">
                {{ t('general.button-cancel') }}
              </button>
            </div>
            <div class="col">
              <button class="btn btn-danger rounded-pill w-100" data-bs-dismiss="modal" type="button" (click)="
                  deleteTransaction(
                    this.selectedTrans?.['_id'],
                    this.selectedTransIndex
                  )
                " title="{{t('general.button-delete')}}">
                {{ t('general.button-delete') }}
              </button>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="transactionDetailsModal" tabindex="-1" aria-labelledby="transactionDetailsModalLabel"
  aria-hidden="true" *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col text-start">

            <div class="d-flex align-items-center justify-content-center">
              <div>
                @if (!this.auth.currentLangSig()?.lang) {
                <div class="placeholder-glow">
                  <span class="placeholder col-8 bg-dark">placeholderText</span>
                </div>
                } @if (this.selectedTrans && this.auth.currentLangSig()?.lang) {


                <h1 class="display-6 text-white rounded-pill bg-text-blue py-0 px-3 mt-0">#{{this.selectedTrans?.['ID']
                  }}</h1>
                }
              </div>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col">


            <div class="card">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span
                      class="material-symbols-outlined align-items-center input-icon-dark-grey me-1">attach_money</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-amount') }}</span>
                    <div class="ms-auto p-1">{{this.selectedTrans?.['Amount']| currency:
                      this.db.currentUserDataSig()?.currency: 'symbol-narrow'}}</div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span class="material-symbols-outlined align-items-center input-icon-dark-grey me-1">event</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-date') }}</span>
                    <div class="ms-auto p-1">{{ this.selectedTrans?.['Date'] }}</div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span
                      class="material-symbols-outlined align-items-center input-icon-dark-grey me-1">view_column</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-category') }}</span>
                    <div class="ms-auto p-1">
                      <div class="row">
                        <div class="col">
                          {{this.selectedTrans?.['Category']}}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          {{this.selectedTrans?.['SubCategory']}}
                        </div>
                      </div>

                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span
                      class="material-symbols-outlined align-items-center input-icon-dark-grey me-1">location_on</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-where') }}</span>
                    <div class="ms-auto p-1">{{ this.selectedTrans?.['Where'] }}</div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span
                      class="material-symbols-outlined align-items-center input-icon-dark-grey me-1 ">format_quote</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-description')
                      }}</span>
                    <div class="ms-auto p-1">{{ this.selectedTrans?.['Description'] }}</div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="d-flex align-items-center">
                    <span class="material-symbols-outlined align-items-center input-icon-dark-grey me-1">wallet</span>
                    <span class="trans-details-header fw-semibold w-30">{{ t('transactions.list-col-method') }}</span>
                    <div class="ms-auto p-1">


                      <div class="row">
                        <div class="col">
                          {{this.selectedTrans?.['Method']}}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          {{this.selectedTrans?.['Account']}}
                        </div>
                      </div>


                    </div>
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="container-fluid">
          @if (!this.auth.currentLangSig()?.lang) {
          <p class="card-text placeholder-glow">
            <span class="placeholder bg-white col-8"></span>
            <span class="placeholder col-4"></span>
          </p>
          } @if (this.auth.currentLangSig()?.lang) {
          <div class="row">
            <div class="col">
              <a class="btn btn-sm btn-link btn-link-secondary" data-bs-target="#deleteTransactionModal"
                data-bs-toggle="modal" title="{{t('transactions.remove-transaction')}}">
                <div class="d-flex align-items-center">
                  <span class="">{{ t('general.button-delete') }}</span>
                </div>
              </a>
            </div>
            <div class="col"><button class="btn btn-sm btn-outline-secondary rounded-pill w-100" data-bs-dismiss="modal"
                type="button" title="{{t('general.button-close')}}">
                {{ t('general.button-close') }}
              </button></div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>